module.exports = __webpack_public_path__ + "img/circle-check-filled.54f6a9be.svg";